export const SET = '/dealership/set';
